module.exports = __webpack_public_path__ + "img/smile.34c92b89.svg";